export enum VisucloudPermissionCategories {
    CanSee,
    HaveAccess,
    DoAction
}
